import { FollowingPreferences } from "@/src/features/following/components";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import { useAuth } from "@/src/contexts/auth.context";
import {
  useGetUserPreferencesQuery,
  useUpdateUserPreferences,
} from "@/src/services/profile/profile.hooks";
import SectionHeader from "../../ui-kit/section-header";
import Toggle from "../../ui-kit/toggle";

/**
 * On/off switch for real-time notification delivery, persisted on the user's
 * `preferences.notificationsEnabled`.
 *
 * Existing profiles predate this field, so `preferences` may come back with
 * `notificationsEnabled` absent (`undefined`) rather than `false`. That must
 * read as "on" — nobody should be silently muted by a field they never set —
 * so the toggle only shows off when the value is explicitly `false`.
 */
const NotificationsSection = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const userId = user?.itemId ?? "";

  const { data: preferences } = useGetUserPreferencesQuery(userId);
  const { mutate: updatePreferences, isPending } = useUpdateUserPreferences();

  const notificationsEnabled = preferences?.notificationsEnabled !== false;

  const handleToggle = (value: boolean) => {
    if (!userId) return;
    updatePreferences({ userId, notificationsEnabled: value });
  };

  return (
    <View>
      <View className="flex-row justify-between items-start">
        <View className="flex-1 pr-4">
          <SectionHeader
            title={t("LABEL_NOTIFICATIONS")}
            subtitle={t("LABEL_NOTIFICATIONS_SETTINGS_DESC")}
          />
        </View>
        <Toggle
          value={notificationsEnabled}
          onChange={handleToggle}
          disabled={isPending || !userId}
        />
      </View>
      <FollowingPreferences />
    </View>
  );
};

export default NotificationsSection;
